import Table from "react-bootstrap/Table";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import Row from "react-bootstrap/Row";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import Swal from "sweetalert2";
import MyDocument from "./MyDocument";
import { ExportToExcel } from "./ExportToExcel";
import { PDFDownloadLink } from "@react-pdf/renderer";
import { CSVLink } from "react-csv";
import ReactPaginate from "react-paginate";

export default function ManageFixedEarning() {
    const [searchText, setSearchText] = useState("");
    const [number, setNumber] = useState(1); // No of pages
    const [PerPage] = useState(20);
    const [ManageMonthlyEarning, setManageMonthlyEarning] = useState([]);
    const fileName = "Eemployee"; // here enter filename for your excel file

    useEffect(() => {
        fetchMonthlyEarning();
    }, []);

    const fetchMonthlyEarning = async () => {
        await axios
            .get(process.env.REACT_APP_API + "/fixed_earning/APILimited")
            .then(({ data }) => {
                setManageMonthlyEarning(data);
            });
    };

    const deleteMonthlyEarning = async (ID) => {
        const isConfirm = await Swal.fire({
            title: "Are you sure?",
            text: "You won't be able to revert this!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes, delete it!",
        }).then((result) => {
            return result.isConfirmed;
        });
        if (!isConfirm) {
            return;
        }
        await axios
            .delete(`${process.env.REACT_APP_API}/fixed_earning/APILimited/${ID}`)
            .then(({ data }) => {
                Swal.fire({
                    icon: "success",
                    timer: 1500,
                    text: data.message,
                });
                fetchMonthlyEarning();
            })
            .catch(({ response: { data } }) => {
                Swal.fire({
                    text: data.message,
                    icon: "error",
                });
            });
    };

    const last = number * PerPage;
    const first = last - PerPage;
    const currentPost = ManageMonthlyEarning.slice(first, last);
    const PageCount = Math.ceil(ManageMonthlyEarning.length / PerPage);
    const ChangePage = ({ selected }) => {
        console.log(selected);
        setNumber(selected);
    };

    // exclude column list from filter
    const excludeColumns = ["id", "date", "name", "e_id"];
    // handle change event of search input
    const handleChange = (value) => {
        setSearchText(value);
        filterData(value);
    };
    // filter records by search text
    const filterData = (value) => {
        const lowercasedValue = value.toLowerCase().trim();
        if (lowercasedValue === "") setManageMonthlyEarning(ManageMonthlyEarning);
        else {
            const filteredData = ManageMonthlyEarning.filter((item) => {
                return Object.keys(item).some((key) =>
                    excludeColumns.includes(key)
                        ? false
                        : item[key]
                              .toString()
                              .toLowerCase()
                              .includes(lowercasedValue)
                );
            });
            setManageMonthlyEarning(filteredData);
        }
    };

    return (
        <div>
            <div className="col-lg-12 bg-white shadow rounded mb-4 border-1 border-secondary">
                <div className="d-flex d-flex justify-content-between mb-2 ">
                    <div className="">
                        <Form className="container card mb-2 mt-2 bg-transparent border-0 m-0">
                            <Row className="">
                                <Form.Group as={Col}>
                                    <div class="row g-3 align-items-center">
                                        <div class="col-auto">
                                            <label
                                                for="search"
                                                class="col-form-label"
                                            >
                                                Search
                                            </label>
                                        </div>
                                        <div class="col-auto">
                                            <input
                                                type="text"
                                                placeholder="search..."
                                                value={searchText}
                                                onChange={(e) =>
                                                    handleChange(e.target.value)
                                                }
                                                id="search"
                                                class="form-control"
                                                aria-describedby="passwordHelpInline"
                                            />
                                        </div>
                                    </div>
                                </Form.Group>
                            </Row>
                        </Form>
                    </div>

                    <div className=" mt-2">
                        <PDFDownloadLink
                            document={<MyDocument />}
                            fileName="Department"
                        >
                            <button
                                className="btn btn btn-primary ms-2"
                                type="button"
                            >
                                <i class="bi bi-file-pdf"></i> PDF
                            </button>
                        </PDFDownloadLink>
                        <ExportToExcel
                            class="mr-5"
                            apiData={ManageMonthlyEarning}
                            fileName={fileName}
                        />
                        <CSVLink
                            class="btn btn-primary ms-2"
                            data={ManageMonthlyEarning}
                        >
                            <i class="bi bi-filetype-csv"></i> CSV
                        </CSVLink>
                    </div>
                </div>
            </div>

            <Table striped bordered hover>
                <thead>
                    <tr>
                    <th>SL</th>
                        <th>E-ID</th>
                        <th>Type</th>
                        <th>Entity</th>
                        {/* <th>Description</th> */}
                        <th>Amount</th>
                        <th>Date</th>
                        {/* <th>Automated</th> */}
                        {/* <th>User</th> */}
                        <th>Action</th>
                    </tr>
                </thead>

                <tbody>
                    {currentPost.length > 0 &&
                        currentPost.map((row, key) => (
                            <tr key={key}>
                                <td>{key + 1}</td>
                                <td>{row.E_ID}</td>
                                <td>{row.Type == 1 ? "Earning" : "Deduction"}</td>
                                <td>{row.Entity}</td>
                                {/* <td>{row.description}</td> */}
                                <td>{row.Amount}</td>
                                <td>{row.Date}</td>
                                {/* <td>{row.Automated}</td> */}
                                {/* <td>{row.User}</td> */}


                                <td>
                                    <Link
                                        to={`/managefixedearning/edit/${row.ID}`}
                                        className="btn btn-success ms-1 manageBranch"
                                    >
                                         <i class="fas fa-edit"> Edit </i>
                                    </Link>

                                    <Link
                                        onClick={() => deleteMonthlyEarning(row.ID)}
                                        className="btn btn-success ms-1 manageBranch"
                                    >
                                        <i class="fa fa-trash"> Delete </i>
                                    </Link>
                                </td>
                            </tr>
                        ))}

                    <div style={{ marginLeft: "400%" }}>
                        {currentPost.length === 0 && (
                            <div class="text-center">
                                <div
                                    class="spinner-border text-center"
                                    role="status"
                                >
                                    <span class="visually-hidden">
                                        Loading...
                                    </span>
                                </div>
                            </div>
                        )}
                    </div>
                </tbody>
            </Table>
            <ReactPaginate
                previousLabel={"Previous"}
                nextLabel={"Next"}
                pageCount={PageCount}
                onPageChange={ChangePage}
                containerClassName={"paginationBttns"}
                activeClassName={"paginationActive"}
                disableInitialCallback={true}
                initialPage={1}
            ></ReactPaginate>
        </div>
    );
}
